import http from "../redux/http";

export const bookmarkPostAPI = async (postId) =>
  http.post(`/blog_posts/${postId}/add_bookmark`);

export const unBookmarkPostAPI = async (postId) =>
  http.delete(`/blog_posts/${postId}/remove_bookmark`);

export const likePostAPI = async (postId) =>
  http.put(`/blog_posts/${postId}/likes`);

export const unlikePostAPI = async (postId) =>
  http.delete(`/blog_posts/${postId}/likes`);
